import React, { useEffect, useRef, useCallback, useState, useMemo } from 'react';
import './BrowserTop.css';
import { f_isSignInWithEmailLink, f_signInWithEmailLink, auth } from '../Util/Firebase';
import { useNavigate, useLocation } from 'react-router-dom';
import AddAccess from '../Util/AddAccess';
import { useTranslation } from 'react-i18next';
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import { isAuthAtom, topMessageAtom, isAuthLoadedAtom } from '../../State';
import DataModel from '../Util/DataModel';
import { ReactComponent as MeetingSVG } from '../Images/buttons/newMeeting.svg';
import { ReactComponent as LiveSVG } from '../Images/buttons/newLive.svg';
import { ReactComponent as CloseSVG } from '../Images/buttons/closeBlackButton.svg';
import { ReactComponent as CopyLinkSVG } from '../Images/buttons/linkCopyGray.svg';
import { ReactComponent as OpenMeetingSVG } from '../Images/buttons/openMeetingButton.svg';
import { ReactComponent as ScheduleSVG } from '../Images/buttons/scheduleIcon2.svg';
import KUTE from 'kute.js';

export default function AddArea({
  showAddArea,
  setShowAddArea,
  callReload,
  setShowLiveState,
  setShowError,
  meetingIDState,
}) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate(); //リダイレクト用
  //Recoil系
  const [authState, setAuthState] = useRecoilState(isAuthAtom);
  const [isAuthLoadedState, setIsAuthLoadedState] = useRecoilState(isAuthLoadedAtom);
  const setTopMessageState = useSetRecoilState(topMessageAtom);

  //その他
  const [isLoadedState, setIsLoadedState] = useState(false);
  const [currentState, setCurrentState] = useState('initial');
  const [meetingID, setMeetingID] = useState(null);
  const [unlimitedState, setUnlimited] = useState(false);

  useEffect(() => {
    if (showAddArea) {
      let kute = KUTE.to(
        '#addAreaWrap',
        { top: '85%' },
        {
          duration: 300,
          easing: 'easingCubicOut',
          onComplete: () => {},
        },
      );
      kute.start();
    }
  }, [showAddArea]);

  const newMeeting = async () => {
    setShowAddArea(false);
    setShowLiveState('newMeeting');

    // //状態変更
    // setCurrentState('creating');

    // //ミーティング作成
    // let result = await DataModel.createNewMeeting('meeting');

    // if (result != null) {
    //   setMeetingID(result.meetingID);
    //   setCurrentState('completed');
    //   setTopMessageState({ type: 'copied', message: t('mypage.Created Successfully!') });
    //   callReload();
    // } else {
    //   setCurrentState('initial');
    //   setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    // }
  };

  //新しいライブ
  const newLive = (e) => {
    setShowAddArea(false);
    setShowLiveState('new');
  };

  //クリップボードにコピー
  const copyURL = (e) => {
    e.stopPropagation();
    const url = 'https://faceless.ooo/' + meetingID;
    navigator.clipboard.writeText(url).then(
      function () {
        setTopMessageState({ type: 'copied', message: t('top.Copied Successfully') });
      },
      function (err) {},
    );
  };

  //無期限に変更
  const changeToUnlimited = async (e) => {
    let result = await DataModel.editMeeting(meetingID, 'unlimited');
    if (result != null) {
      if (result.status == 'already exist') {
        setShowError('unlimited');
      } else {
        setTopMessageState({ type: 'copied', message: t('mypage.Made it unlimited successfully') });
        setUnlimited(true);
        callReload();
      }
    } else {
      setTopMessageState({ type: 'copied', message: t('mypage.Error something wrong') });
    }
  };

  //新しいミーティング
  const joinMeeting = async (e) => {
    // e.stopPropagation();
    navigate('/' + meetingID);
  };

  //クリップボードにコピー
  const closeWindow = (e) => {
    if (currentState == 'creating') return;
    setShowAddArea(false);
  };

  if (showAddArea == false) {
    return false;
  }

  return (
    <>
      <div className="addAreaBack" onClick={closeWindow}></div>

      {currentState == 'creating' && (
        <div className="addAreaCompletedWrap">
          <div className="addAreaLoading">
            <div className="loader">
              <svg className="circular-loader" viewBox="25 25 50 50">
                <circle
                  className="loader-path-gray"
                  cx="50"
                  cy="50"
                  r="20"
                  fill="none"
                  stroke="#70c542"
                  strokeWidth="2"
                />
              </svg>
            </div>
          </div>
        </div>
      )}

      {currentState == 'completed' && (
        <div className="addAreaCompletedWrap">
          <div className="addAreaCompletedTitle">{t('mypage.Meeting URL')}</div>
          <div className="addAreaCompletedBody" onClick={changeToUnlimited}>
            {unlimitedState ? (
              <>{t('mypage.Unlimited Meeting (No expiration)')}</>
            ) : (
              <>
                {t('mypage.This meeting expires in 7 days.')}
                <span>{t('mypage.Make it unlimited')}</span>
              </>
            )}
          </div>
          <div className="addAreaClose" onClick={closeWindow}>
            <CloseSVG />
          </div>

          <div className="addAreaInput" onClick={copyURL}>
            <div id="topID">faceless.ooo/{meetingID != null && meetingID}</div>
            <div>
              <CopyLinkSVG />
            </div>
          </div>
          <div className="addAreaButton" onClick={joinMeeting}>
            {t('mypage.Start Now')}
          </div>
        </div>
      )}

      {currentState == 'initial' && (
        <div id="addAreaWrap" style={{}}>
          <div
            className="addAreaItem"
            onClick={() => {
              navigate('/' + meetingIDState);
            }}>
            <OpenMeetingSVG />
            <div>
              <div className="addAreaTitle"> {t('mypage.Open My Meeting Room')}</div>
              <div className="addAreaBody">faceless.ooo/{meetingIDState} </div>
            </div>
          </div>

          <div className="addAreaItem" onClick={newMeeting}>
            <ScheduleSVG />
            <div>
              <div className="addAreaTitle"> {t('mypage.New Meeting')}</div>
              <div className="addAreaBody"> {t('mypage.Schedule a private meeting')}</div>
            </div>
          </div>

          <div className="addAreaItem" onClick={newLive}>
            <LiveSVG />
            <div>
              <div className="addAreaTitle"> {t('mypage.New Live')}</div>
              <div className="addAreaBody"> {t('mypage.Up to 1,000 participants')}</div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
